// src/components/Preloader.jsx
import { useEffect, useRef, useState } from "react";
import "../Preloader.css";
import { useAppTranslation } from "./TranslationContext";

export const Preloader = ({ ready, onFinish, minShowMs = 800 }) => {
  const { t } = useAppTranslation();
  const textTop = t("preloaderTitle");
  const textBottom = t("preloaderSub");

  const [progress, setProgress] = useState(0);
  const [hidden, setHidden] = useState(false);
  const startedAtRef = useRef(Date.now());
  const rafRef = useRef(0);

  // Лёгкая симуляция прогресса: пока !ready — растём до 90%; когда ready — идём к 100
  useEffect(() => {
    const tick = () => {
      setProgress((p) => {
        const target = ready ? 100 : 90;
        // скорость подстраиваем так, чтобы движение было плавным
        const delta = Math.max(0.5, (target - p) * 0.07);
        const next = Math.min(target, p + delta);
        return next;
      });
      rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [ready]);

  // Когда доросли до 100 — ждём minShowMs и плавно скрываем
  useEffect(() => {
    if (progress < 100) return;
    const elapsed = Date.now() - startedAtRef.current;
    const waitMore = Math.max(0, minShowMs - elapsed);

    const to = setTimeout(() => setHidden(true), waitMore);
    return () => clearTimeout(to);
  }, [progress, minShowMs]);

  // После CSS-анимации скрытия — сигналим родителю
  useEffect(() => {
    if (!hidden) return;
    const to = setTimeout(() => onFinish?.(), 400); // совпадает с transition
    return () => clearTimeout(to);
  }, [hidden, onFinish]);

  return (
    <div className={`preloader ${hidden ? "hide" : ""}`} aria-hidden={hidden}>
      <div className="preloader-content">
        <h1 className="text-line top">
          {textTop.split("").map((ch, i) => (
            <span key={i} style={{ animationDelay: `${i * 0.06}s` }}>{ch}</span>
          ))}
        </h1>
        <h2 className="text-line bottom">
          {textBottom.split("").map((ch, i) => (
            <span key={i} style={{ animationDelay: `${(textBottom.length - i) * 0.06}s` }}>{ch}</span>
          ))}
        </h2>

        <div className="progress" role="progressbar" aria-valuenow={Math.round(progress)} aria-valuemin={0} aria-valuemax={100}>
          {Math.round(progress)}%
        </div>
      </div>
    </div>
  );
};
